import { useCart } from "../cart/CartContext";

export default function StoreHeader({ store, storeSlug }) {
  const { itemCount } = useCart();
  const storeUrl = `/commerce/${encodeURIComponent(
    store?.slug || storeSlug
  )}`;
  const cartUrl = `${storeUrl}/cart`;
  const name = store?.name || "Carregando loja...";

  return (
    <header className="store-header">
      <div className="store-header__inner">
        <a className="store-header__brand" href={storeUrl}>
          <div className="store-mark" aria-hidden>
            {name === "Carregando loja..."
              ? "A"
              : name.slice(0, 1).toLocaleUpperCase()}
          </div>
          <div>
            <p className="store-header__label">Loja oficial</p>
            <p className="store-header__name">{name}</p>
          </div>
        </a>

        <a
          className="header-cart"
          href={cartUrl}
          aria-label={`Carrinho com ${itemCount} ${
            itemCount === 1 ? "item" : "itens"
          }`}
        >
          <svg viewBox="0 0 24 24" aria-hidden>
            <path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L20.2 8H6.1M9.5 20a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
          </svg>
          {itemCount > 0 && <span>{itemCount > 99 ? "99+" : itemCount}</span>}
        </a>
      </div>
    </header>
  );
}
